export default __webpack_public_path__ + "static/media/(24).73e78fa4.jpeg";